import React, { useMemo } from 'react';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';

import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import {
    WalletModalProvider
} from '@solana/wallet-adapter-react-ui';


// Default styles that can be overridden by your app
require('@solana/wallet-adapter-react-ui/styles.css');

export const SolanaWalletProvider = ({ children }) => {


    // You can also provide a custom RPC endpoint.
    const endpoint = useMemo(() => {
        const envReact = (process.env.REACT_APP_SOLANA_RPC_HTTP_URL || '').replace(/^"|"$/g, '');
        const envPlain = (process.env.SOLANA_RPC_HTTP_URL || '').replace(/^"|"$/g, '');
        const envUrl = envReact || envPlain;

        // Fallback to mainnet-beta if no env var is provided (prevents crash)
        return envUrl || "https://api.mainnet-beta.solana.com";
    }, []);

    const wallets = useMemo(
        () => [
            new PhantomWalletAdapter(),
            new SolflareWalletAdapter(),
        ],
        []
    );

    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect>
                <WalletModalProvider>
                    {children}
                </WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};
